import { VueFireAuth } from "vuefire";
import { firebaseApp } from "../../firebase";

export default {
  firebaseApp,
  modules: [VueFireAuth()],
};
